import { ChevronUpIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";
import { Visible } from "components/Visible";
import { useState, useEffect } from "react";

const BackToTop = () => {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 400) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        });
    }, []);

    const onGoToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <Visible when={showButton}>
            <Flex position='absolute' right="3%" bottom="5%" flexDirection='row' alignItems='center'>
          <Text display={['none', 'none', 'block']} marginRight={5}>Back to Top</Text>
                <ChevronUpIcon
                    w={10} 
                    borderRadius={80}
                    onClick={onGoToTop}
                    h={10}
                    borderWidth={0}
                    cursor='pointer'
                    boxShadow='41px 33px 41px 30px rgb(169 151 151 / 10%), 0px 10px 10px -5px rgb(151 151 151 / 4%)'
          />
            </Flex>
        </Visible>
    )
  };

  export { BackToTop };